import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { IconBadge } from '@/components/atoms';
import { type IconKey } from '@/content/site';

type Props = { icon: IconKey; title: string; id?: string };

/** Brand-red section title with its icon, used by every footer group. */
export function FooterHeading({ icon, title, id }: Props) {
  return (
    <Stack direction="row" alignItems="center" spacing={3}>
      <IconBadge name={icon} size={36} shape="circle" tone="tint" />
      <Typography id={id} component="h2" variant="h6" sx={{ color: 'primary.main' }}>
        {title}
      </Typography>
    </Stack>
  );
}
